import { setAttendingsRequest } from '../../core/attending';
import {
  Provider,
  Worksheet
} from '../../core/domain';
import { FormApi, formApi, providerField } from '../../core/form';
import { personName } from '../../core/format';
import { showSuccessMessage, showToast } from '../../core/toast';

export function ownerForm(
  physicians: Provider[],
  sheet: Worksheet,
  onAttendingChanged: (a: Provider) => void,
  disabled?: boolean
): FormApi<{ owner: Provider }> {
  return formApi({
    disabled,
    values: { owner: sheet.owningProvider },
    fields: {
      owner: providerField(physicians, { label: 'Worksheet Attending' }),
    },
    onChange: async (v) => {
      const current = sheet?.owningProvider;
      // Fire when the selected provider differs from the stored owner. Compare
      // by name as well as providerId: when the ADT/clinicals arrive before the
      // provider exists for the location, the owner is stored with the right
      // providerId but a placeholder UNKNOWN name. Selecting the now-created
      // provider (same providerId) must still re-set the attending so the name
      // resolves and setPhysician runs.
      const changed =
        v?.owner &&
        (v.owner.providerId !== current?.providerId ||
          personName(v.owner) !== personName(current));
      if (changed) {
        const data = { ...{ worksheetId: sheet.worksheetId }, ...v.owner };
        const result = await setAttendingsRequest(data);

        if (result.success) {
          if (onAttendingChanged) {
            onAttendingChanged(v.owner);
          }
          showSuccessMessage(
            personName(v.owner) + ' is now the worksheet attending.'
          );
        } else {
          showToast(
            'There was an error seting the attending:' +
              (result.errors || []).join('\n')
          );
        }
      }
    },
  });
}
